"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SyncSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M8,25H5a1,1,0,0,1-1-1V8A1,1,0,0,1,5,7H16.586L14.293,9.293a1,1,0,1,0,1.414,1.414l4-4h0a1,1,0,0,0,0-1.414h0l-4-4a1,1,0,0,0-1.414,1.414L16.586,5H5A3,3,0,0,0,2,8V24a3,3,0,0,0,3,3H8a1,1,0,0,0,0-2Z"/><path d="M27,5H24a1,1,0,0,0,0,2h3a1,1,0,0,1,1,1V24a1,1,0,0,1-1,1H15.414l2.293-2.293a1,1,0,1,0-1.414-1.414l-4,4h0a1,1,0,0,0,0,1.414h0l4,4a1,1,0,0,0,1.414-1.414L15.414,27H27a3,3,0,0,0,3-3V8A3,3,0,0,0,27,5Z"/>';
var SyncSVG = function SyncSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SyncSVG = SyncSVG;
SyncSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SyncSVG);
exports.default = _default;